<button
	mat-button
	class="filter-button"
	[ngClass]="filterButtonClass"
	[matMenuTriggerFor]="dropdownMultiSelectMenu"
	#menuTrigger="matMenuTrigger"
	(menuOpened)="handleMenuOpen()"
	[attr.aria-haspopup]="'dialog'"
	[attr.aria-expanded]="showMenu"
	[attr.aria-controls]="showMenu ? menuTrigger?.menu?.panelId : null"
	[attr.aria-label]="(dropdownLabel || selectedOption) ? (dropdownLabel + ' ' + selectedOption) : ('filter menu' | i18next)"
>
	<span
		*ngIf="showLabel"
		class="filter-button-label"
		[ngClass]="filterButtonLabelClass"
	>
		{{ dropdownLabel }}
	</span>
	<span
		class="filter-button-text"
		[ngClass]="filterButtonTextClass"
	>
		{{ selectedOption }}
	</span>
	<mat-icon>{{ buttonIconValue }}</mat-icon>
</button>
<mat-menu
	#dropdownMultiSelectMenu="matMenu"
	xPosition="after"
	[attr.aria-label]="dropdownLabel || ('filter options' | i18next: { format: 'capitalize' })"
	class="multi-select-dropdown-menu"
	(closed)="handleMenuClose()"
>
	<div
		#dialogWrapper
		cdkTrapFocus
		cdkTrapFocusAutoCapture="true"
		role="dialog"
		aria-modal="true"
		[attr.aria-label]="dropdownLabel || ('filter options' | i18next: { format: 'capitalize' })"
		(keydown)="handleMenuKeydown($event)"
		(keydown.escape)="menuTrigger.closeMenu()"
	>
	<app-search-input
		(click)="searchInputClicked($event)"
		(inputChanged)="inputChanged($event)"
		[inputStr]="inputStr"
		[resetInput]="resetInput"
		[placeholder]="'search' | i18next: { format: 'capitalize' }"
		>
	</app-search-input>
	<app-action-button
		title="clear selected"
		id="deselect-box"
		(buttonClicked)="clearSelected($event)"
		[disabled]="!potentiallySelectedOptions.length"
	>
	</app-action-button>
	<div
		class="option-checkbox-container"
		*ngIf="showMenu"
		tabindex="0"
		role="listbox"
		style="outline: none"
		(focus)="focusFirstOption()"
		(click)="$event.stopPropagation()"
	>
		<div
			*ngFor="let option of sortedOptions"
			class="option-checkbox-wrapper"
		>
			<mat-checkbox
				tabindex="-1"
				[id]="instanceId + '-' + option.value"
				class="option-checkbox"
				[ngClass]="{ 'hide-checkbox': option.label === 'Loading...' }"
				(click)="matCheckboxClick($event)"
				(change)="matCheckboxChange($event, option)"
				[checked]="isMultiSelect ? defaultCheckState[option.value] : singleSelectedItem?.value === option?.value"
				[disabled]="option.label === 'Loading...'"
			>
				<img
					*ngIf="option.icon"
					class="option-icon"
					[src]="option.icon"
					alt=""
				/>

				<ng-container *ngIf="isInspectionType(); else normalLabel">
					<span *ngIf="option.label | splitAtFirstDelimiter as parts">
						<span>{{ parts[0] }}</span>
						<span
							class="other-parts"
							*ngIf="parts.length > 1"
						>
							{{ parts[1] }}
						</span>
					</span>
				</ng-container>

				<ng-template #normalLabel>
					<span>{{ option.label }}</span>
				</ng-template>
			</mat-checkbox>
			<br />
		</div>
	</div>
	<div class="action-button-container">
		<app-action-button
			title="cancel"
			type="outlined-1"
			[style.marginRight.px]="16"
			(buttonClicked)="menuTrigger.closeMenu()"
		></app-action-button>

		<app-action-button
			title="apply"
			(buttonClicked)="dropdownSubmit()"
		></app-action-button>
	</div>
	</div>
</mat-menu>
